import Vue from "vue";
import Axios from "axios";
import "./plugins/fontawesome";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import VueProgressBar from "vue-progressbar";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "ant-design-vue/dist/antd.css";
import "./App.css";
import "jquery/src/jquery.js";
import "bootstrap/dist/js/bootstrap.min.js";
import VueTypedJs from "vue-typed-js";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faVuejs,
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import JQuery from "jquery";
window.$ = JQuery;
window.JQuery = JQuery;

library.add(
  faVuejs,
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  faGithub
);

const options = {
  color: "#2049ba",
  failedColor: "#874b4b",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
};

Vue.prototype.$http = Axios;
Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(VueProgressBar, options);
Vue.use(VueTypedJs);
Axios.defaults.withCredentials = true;

const token = localStorage.getItem("token");
if (token) {
  // Axios.defaults.header.common["Authorization"] = token;
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
